export default "__VITE_ASSET__JFoUEYQk__"